import axios from 'axios';

import http from '@/services/http.js';
import { getJianyingVideoContentType } from '../utils/jianyingVideoUpload.js';

const JIANYING_API = '/videoapi/jianying';

export const uploadJianyingJobVideo = async ({
  clientId,
  file,
  slotId,
  templateId,
  fileDurationUs,
  sourceStartUs,
  sourceDurationUs,
}) => {
  const contentType = getJianyingVideoContentType(file);
  const signingResponse = await http.post(`${JIANYING_API}/jobs/video/upload-url`, {
    client_id: clientId,
    jianying_template_id: templateId,
    slot_id: slotId,
    file_name: file.name,
    content_type: contentType,
    file_size: file.size,
  });
  const signed = signingResponse.data.data;
  await axios.put(signed.uploadUrl || signed.upload_url, file, {
    headers: signed.headers,
  });
  return {
    kind: 'video',
    object_key: signed.object_key,
    file_name: file.name,
    file_duration_us: fileDurationUs,
    source_start_us: sourceStartUs,
    source_duration_us: sourceDurationUs,
  };
};

export const cleanupJianyingJobVideo = async ({
  clientId,
  objectKeys,
}) => {
  const keys = [...new Set(objectKeys || [])].filter(Boolean);
  if (!clientId || keys.length === 0) return { deleted: [], retained: [] };
  const response = await http.post(`${JIANYING_API}/jobs/video/cleanup`, {
    client_id: clientId,
    object_keys: keys,
  });
  return response.data.data;
};
